import { createContext, useEffect, useState } from "react";
import { Homepage, Services, About, Portfolio, Blog, Contact, } from "./view";
import Header from "view/lib/components/header";
import { Page } from "services/models";
import { Div } from "view/lib/components";
import data from "data.json";
import animate from "view/lib/components/animated";

interface Context {
  readonly setPage: (pages: ReadonlyArray<Page>) => void;
}

const Context = createContext<Context | undefined>(undefined);

const App = () => {
  const [pages, setPage] = useState<ReadonlyArray<Page>>([Page.Home]);

  const addPage = (page: Page) => setPage([...pages, page]);

  const page = (pages.length && pages.at(-1)) || Page.Home;

  return <Context.Provider value={{setPage}}>
    <Header page={page} setPage={addPage}/>
    <Div style={styles.container}>
      {page === Page.Home && <Homepage data={data.home}/>}
      {page === Page.Services && animate(<Services data={data.services}/>)}
      {page === Page.About && animate(<About goToPortfolio={() => addPage(Page.Portfolio)} data={data.about}/>)}
      {page === Page.Portfolio && animate(<Portfolio data={data.portfolio}/>)}
      {page === Page.Blog && animate(<Blog />)}
      {page === Page.Contact && animate(<Contact data={data.contact}/>)}
    </Div>
  </Context.Provider>;
}

const styles = {
  container: {
    height: "100%",
  }
} as const;

export default App;
